import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import UserService from "../services/UserService";

export default function StaffManagement() {
  const [staff, setStaff] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Podaci o trenutno ulogovanom korisniku
  const currentUser = AuthService.getCurrentUser();
  const isAdmin = currentUser?.roles?.includes("ROLE_ADMIN");
  
  // Provera ID-a trenutnog korisnika
  const currentUserId = currentUser?.id || currentUser?.userID;

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      setLoading(true);
      const data = await UserService.getAllStaff();
      setStaff(data);
      setError("");
    } catch (err) {
      console.error("Greška pri učitavanju osoblja:", err);
      setError("Neuspešno učitavanje liste osoblja. Proverite konekciju sa serverom.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Da li ste sigurni da želite da obrišete ovog korisnika?")) {
      try {
        await UserService.deleteUser(id);
        setStaff(staff.filter((u) => u.userID !== id));
      } catch (err) {
        console.error("Greška pri brisanju:", err);
        setError("Greška pri brisanju korisnika. Proverite prava pristupa.");
      }
    }
  };

  const getRoleBadge = (roles) => {
    if (!roles) return null;
    return roles.map((role) => {
      let badgeClass = "bg-secondary";
      if (role === "ROLE_ADMIN") badgeClass = "bg-danger";
      if (role === "ROLE_DOCTOR") badgeClass = "bg-primary";
      if (role === "ROLE_NURSE") badgeClass = "bg-success";
      
      return (
        <span key={role} className={`badge ${badgeClass} me-1`}>
          {role.replace("ROLE_", "")}
        </span>
      );
    });
  };

  if (loading) {
    return (
      <div className="container mt-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Učitavanje...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Upravljanje Zaposlenima</h2>
        {isAdmin && (
          <button 
            className="btn btn-primary" 
            onClick={() => navigate("/staff/new")}
          >
            + Dodaj Novo Osoblje
          </button>
        )}
      </div>

      {error && <div className="alert alert-danger shadow-sm">{error}</div>}

      <div className="card shadow-sm border-0">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-dark">
              <tr>
                <th>Korisničko Ime</th>
                <th>Uloge</th>
                <th>Ime i Prezime / Profil</th>
                <th className="text-end">Akcije</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-muted">
                    Nema pronađenih članova osoblja.
                  </td>
                </tr>
              ) : (
                staff.map((u) => {
                  const isMe = u.userID === currentUserId;
                  const canEdit = isAdmin || isMe;

                  return (
                    <tr key={u.userID} className={isMe ? "table-info" : ""}>
                      <td>
                        <span className="fw-bold">{u.username}</span>
                        {isMe && <span className="ms-2 badge bg-dark small">VI</span>}
                      </td>
                      <td>{getRoleBadge(u.roles)}</td>
                      <td>
                        {/* PRIKAZ IMENA I PREZIMENA */}
                        {u.firstName || u.lastName ? (
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark">
                              {u.firstName} {u.lastName}
                            </span>
                            <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                              {u.doctorId ? `DOKTOR (ID: ${u.doctorId})` : `SESTRA (ID: ${u.nurseId})`}
                            </small>
                          </div>
                        ) : (
                          <span className="text-muted small italic">Administrator nalog</span>
                        )}
                      </td>
                      <td className="text-end">
                        {canEdit ? (
                          <div className="btn-group">
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => navigate(`/staff/edit/${u.userID}`)}
                            >
                              Izmeni
                            </button>
                            {isAdmin && !isMe && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(u.userID)}
                              >
                                Obriši
                              </button>
                            )}
                          </div>
                        ) : (
                          <span className="text-muted small">Samo pregled</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}